// extracted by mini-css-extract-plugin
export default {"circle":"CalloutAvatar_circle_A5Guv","image":"CalloutAvatar_image_GTlv7"};